import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from '../utils/i18n';

interface SupportedLocale {
  lang: string;
  name: string;
  flag: string;
  lang_short: string;
}

const supportedLocales: SupportedLocale[] = [
  {
    lang: "th-TH",
    name: "ไทย",
    flag: "Th",
    lang_short: "th",
  },
  {
    lang: "en-US", 
    name: "English",
    flag: "Us",
    lang_short: "en",
  }
];

const LocaleSelector: React.FC = () => {
  const [open, setOpen] = useState(false);
  const { t, language, setLanguage } = useTranslation();
  const dropdownRef = useRef<HTMLDivElement>(null);

  const closeDropDown = () => {
    setOpen(false);
  };

  const changedLocale = (value: string) => {
    closeDropDown();
    setLanguage(value === 'th-TH' ? 'th' : 'en');
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        closeDropDown();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const ThaiFlag = () => (
    <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="2.5" fill="#ED1C24"/>
      <rect y="2.5" width="20" height="2.5" fill="#FFFFFF"/>
      <rect y="5" width="20" height="5" fill="#241D4F"/>
      <rect y="10" width="20" height="2.5" fill="#FFFFFF"/>
      <rect y="12.5" width="20" height="2.5" fill="#ED1C24"/>
    </svg>
  );

  const USFlag = () => (
    <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="15" fill="#012169"/>
      <path d="M0 0L20 15M20 0L0 15" stroke="#FFFFFF" strokeWidth="2"/>
      <path d="M0 0L20 15M20 0L0 15" stroke="#C8102E" strokeWidth="1"/>
      <path d="M10 0V15M0 7.5H20" stroke="#FFFFFF" strokeWidth="3"/>
      <path d="M10 0V15M0 7.5H20" stroke="#C8102E" strokeWidth="2"/>
    </svg>
  );

  const currentLocale = supportedLocales.find(locale => 
    locale.lang_short === language || locale.lang === `${language}-${language.toUpperCase()}`
  ) || supportedLocales[0];

  return (
    <div className="position-relative" ref={dropdownRef} style={{}}>
      <button
       
        type="button"
        onClick={() => setOpen(!open)}
        className="btn btn-outline-primary text-start d-flex justify-content-between align-items-center px-4 py-2 w-auto rounded-pill white-bg"
        style={{ minWidth: '120px' }}
      >
        <span>{t("settings.preferences.language")}</span>
        <div className="ms-2">
          <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </button>

      {open && (
        <div
          className="dropdown-menu show position-absolute end-0 mt-2 shadow-lg rounded-3 border-0"
          style={{ minWidth: '160px', zIndex: 1000 }}
        >
          {supportedLocales.map((locale) => (
            <button
              key={locale.lang}
              type="button"
              onClick={() => changedLocale(locale.lang)}
              className="dropdown-item d-flex align-items-center px-4 py-2 text-start text-dark bg-white border-0 rounded-2 mb-1"
              style={{ cursor: 'pointer' }}
            >
              <div className="me-3">
                {locale.flag === "Th" ? <ThaiFlag /> : <USFlag />}
              </div>
              <span>{locale.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LocaleSelector;
